export const getEndDate = (date) => {
  const endDate = new Date(date);
  endDate.setUTCHours(23, 59, 59, 999); // Normalize to end of day UTC
  return endDate.toISOString();
};
